"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2507],{

/***/ 52507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["default"] = ((0,client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    d: "M20.62 9C21.46 8.27 22 7.2 22 6C22 3.79 20.21 2 18 2C15.79 2 14 3.79 14 6C14 6.2 14.03 6.4 14.06 6.59C13.46 6.22 12.76 6 12 6C11.24 6 10.54 6.22 9.94 6.59C9.97 6.4 10 6.2 10 6C10 3.79 8.21 2 6 2C3.79 2 2 3.79 2 6C2 7.2 2.54 8.27 3.38 9C2.54 9.73 2 10.8 2 12V21C2 21.55 2.45 22 3 22H21C21.55 22 22 21.55 22 21V12C22 10.8 21.46 9.73 20.62 9ZM18 4C19.1 4 20 4.9 20 6C20 7.1 19.1 8 18 8C16.9 8 16 7.1 16 6C16 4.9 16.9 4 18 4ZM12 8C13.1 8 14 8.9 14 10C14 11.1 13.1 12 12 12C10.9 12 10 11.1 10 10C10 8.9 10.9 8 12 8ZM4 6C4 4.9 4.9 4 6 4C7.1 4 8 4.9 8 6C8 7.1 7.1 8 6 8C4.9 8 4 7.1 4 6ZM4 12C4 10.9 4.9 10 6 10C7.1 10 8 10.9 8 12V20H4V12ZM10 16C10 14.9 10.9 14 12 14C13.1 14 14 14.9 14 16V20H10V16ZM20 20H16V12C16 10.9 16.9 10 18 10C19.1 10 20 10.9 20 12V20Z"
}), "FamilyFriendly"));


/***/ })

}]);